/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Permissions_Save_ButtonInputs */



/**
* | output |
* | --- |
* | "Save Permissions" |
*
* @param {Explorer_Info_Permissions_Save_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_permissions_save_button = /** @type {((inputs?: Explorer_Info_Permissions_Save_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Permissions_Save_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer les autorisations")
	if (locale === "de") return /** @type {LocalizedString} */ ("Berechtigungen speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva autorizzazioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранить разрешения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar permisos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存权限")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保存権限")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुमतियाँ सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar permissões")
	return /** @type {LocalizedString} */ ("Save Permissions")
});